// extracted by css-extract-rspack-plugin
export default {"DiffPlaceholderSVG":"DiffPlaceholder-module__DiffPlaceholderSVG__EwJUb"};